import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Module } from 'components/misc'
import { Input, InputPhone, Select } from 'components/fields'

export default class OfficeAuthorisingContact extends Component {
  static propTypes = {
    titles: PropTypes.array.isRequired,
    phoneTypes: PropTypes.array.isRequired
  }

  render() {
    return (
      <Module
        title="Authorising Contact"
        intlKey="moduleTitle.authorising_contact"
        narrow
      >
        <div className="row">
          <div className="col-xs-3">
            <Select
              label="Titles"
              name="authorizingContact.title"
              intlKey="label.title"
              options={this.props.titles}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Input
              label="First Name"
              intlKey="label.first_name"
              name="authorizingContact.firstName"
            />
          </div>
          <div className="col-xs-6">
            <Input
              label="Last Name"
              intlKey="label.last_name"
              name="authorizingContact.lastName"
            />
          </div>
          <div className="col-xs-12">
            <Input
              label="Email"
              intlKey="label.email"
              name="authorizingContact.email"
            />
          </div>
          <div className="col-xs-6">
            <InputPhone
              label="Phone number"
              intlKey="label.phone_number"
              name="authorizingContact.phoneNumber"
            />
          </div>
          <div className="col-xs-6">
            <Select
              label="Phone type"
              intlKey="label.phone_type"
              name="authorizingContact.phoneType"
              options={this.props.phoneTypes}
            />
          </div>
        </div>
      </Module>
    )
  }
}
